import Vue from 'vue'
import Vuex from 'vuex'

// modules.
import auth from './auth'
import growler from './growler'
import ui from './ui'

Vue.use(Vuex)

export default new Vuex.Store({

  modules: {
    auth,
    growler,
    ui
  },

  state: {
    packageVersion: process.env.PACKAGE_VERSION || '0'
  },

  mutations: {},

  actions: {},

  getters : {
    
    appVersion: (state) => {
      return state.packageVersion
    },
    
  }
})